import { apiSlice } from "../apiSlice";

const AUTH_URL = "/user";

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (data) => ({
        url: `${AUTH_URL}/login`,
        method: "POST",
        body: data,
      }),
    }),

    signup: builder.mutation({
      query: (data) => ({
        url: `${AUTH_URL}/signup`,
        method: "POST",
        body: data,
      }),
    }),

    googleLogin: builder.mutation({
      query: (data) => ({
        url: `${AUTH_URL}/google`,
        method: "POST",
        body: data,
      }),
    }),

    logout: builder.mutation({
      query: () => ({
        url: `${AUTH_URL}/logout`,
        method: "POST",
      }),
    }),

    markAnnouncementSeen: builder.mutation({
      query: (version) => ({
        url: `${AUTH_URL}/announcement`,
        method: "PATCH",
        body: { version },
      }),
    }),

    // NOTE: password-reset endpoints were removed — the backend has no
    // implementation. Re-add here together with the routes + an email
    // provider (token-based reset) when that flow is actually built.
  }),
});

export const {
  useLoginMutation,
  useSignupMutation,
  useGoogleLoginMutation,
  useLogoutMutation,
  useMarkAnnouncementSeenMutation,
} = authApiSlice;
